import { render, staticRenderFns } from "./emailList.vue?vue&type=template&id=0bcba6dd&scoped=true&"
import script from "./emailList.vue?vue&type=script&lang=js&"
export * from "./emailList.vue?vue&type=script&lang=js&"
import style0 from "./emailList.vue?vue&type=style&index=0&id=0bcba6dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcba6dd",
  null
  
)

export default component.exports